export const ALL_ITEM_PREMIUM_PAPER_BAGS = [
  {
    categry: "premiumPaperBags",
    itemList: [
      {
        itemSelected: "emilia",
        itemName: "Emilia",
        itemDescription:
          "Emilia is a jewelry box set which can be customized to meet your needs. It comes in a variety of sizes to handle all kinds of jewelry.",

        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/premiumPaperBags/Emilia/Desktop/700x700px/lussopack-premiumpaperbags-emilia.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/premiumPaperBags/Emilia/Desktop/130x130px/lussopack-premiumpaperbags-emilia.webp",
        ],
        itemMobileBig: [
          "/images/listItem/premiumPaperBags/Emilia/Mobile/335x335px/lussopack-premiumpaperbags-emilia.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/premiumPaperBags/Emilia/Mobile/100x100px/lussopack-premiumpaperbags-emilia.webp",
        ],
      },
    ],
  },
];
